import React, { useCallback, useEffect, useRef } from 'react';

/**
 * Fire effect after a specified amount of time.
 *
 * @param effect Code to run
 * @param dependencies Effect's dependencies
 * @param timeout Time in milliseconds until effect should run
 *
 * @return function Function to cancel effect
 */
const useDelayedEffect = (
  effect: React.EffectCallback,
  dependencies: React.DependencyList,
  timeout: number
) => {
  const timeoutRef = useRef<number>(0);

  useEffect(() => {
    timeoutRef.current = window.setTimeout(effect, timeout);

    return () => clearTimeout(timeoutRef.current);
  }, [timeout, ...dependencies]); // eslint-disable-line react-hooks/exhaustive-deps

  return useCallback(() => {
    clearTimeout(timeoutRef.current);
  }, []);
};

export default useDelayedEffect;
